export const colors = {
  1: "#493ED380",
  2: "#FF86FF",
  3: "#C0F73780",
  4: "#FFBA5E80",
  5: "#5656FF80",
  6: "#F5F5F5",
  7: "#FFDAFF",
  8: "#A8A1FF",
  9: "#D9F19F",
  10: "#FFDAFF",
  11: "#A8A1FF",
  Պատմություն: "#FFDAFF",
  Աշխարհագրություն: "#D9F19F",
  "Հայոց Լեզու": "#FFDEB2",
  "Իմ Հայրենիքը": "#FFDAFF",
  Գրականություն: "#FF86FF",
  "Հասարակագիտություն": "#C0F73780",
};
